@use '@lib/assets/styles/main.scss' as *;

.root {
  display: block;
  min-width: 0;
  max-width: 100%;
}

.text {
  display: block;
  max-width: 100%;
}

.singleLine {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.multiLine {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
